import React, { useState, useMemo } from "react";

export default function Flowchart({ 
  subjects = [], 
  department = '', 
  yearLabel = ''
}) {
  const [selected, setSelected] = useState(null);

  const years = ['First Year', 'Second Year', 'Third Year', 'Fourth Year'];
  const semesters = ['First Semester', 'Second Semester'];

  const subjectsBySlot = (y, s) => subjects.filter(sub => (sub.yearLevel || '').toLowerCase() === y.toLowerCase() && (sub.semester || '').toLowerCase() === s.toLowerCase());

  const slotLists = useMemo(() => years.flatMap(y => semesters.map(s => subjectsBySlot(y, s))), [subjects]);
  const maxRows = Math.max(0, ...slotLists.map(list => list.length));

  return (
    <div style={{ marginTop: 28 }}>
      <h3 style={{ marginBottom: 12 }}>Flowchart {yearLabel ? `— ${yearLabel}` : ''}</h3>

      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${years.length * 2}, 1fr)`, gap: 0, border: '1px solid #333' }}>
        {/* Year headers */}
        {years.map((y, idx) => (
          <div key={y} style={{ gridColumn: `span 2`, padding: '8px 6px', textAlign: 'center', fontWeight: 'normal', fontSize: 14, borderRight: idx < years.length - 1 ? '1px solid #333' : 'none', background: '#fff' }}>{y}</div>
        ))}

        {/* Semester row */}
        {years.map((y, idx) => (
          <React.Fragment key={y + '-sem'}>
            <div style={{ padding: 6, textAlign: 'center', fontWeight: 'normal', fontSize: 12, borderTop: '1px solid #333', borderRight: '1px solid #333', background: '#fafafa' }}>First Semester</div>
            <div style={{ padding: 6, textAlign: 'center', fontWeight: 'normal', fontSize: 12, borderTop: '1px solid #333', borderRight: idx < years.length - 1 ? '1px solid #333' : 'none', background: '#fafafa' }}>Second Semester</div>
          </React.Fragment>
        ))}

        {/* Subject rows with color coding */}
        {Array.from({ length: Math.max(1, maxRows) }).map((_, rowIdx) => (
          years.map((y, yIdx) => (
            semesters.map((s, sIdx) => {
              const list = subjectsBySlot(y, s);
              const subj = list[rowIdx];
              const bgColor = subj?.statusColor || '#f5f5f5';
              const isLastYear = yIdx === years.length - 1;
              
              return (
                <div
                  key={`${y}-${s}-${rowIdx}`}
                  onClick={() => subj && setSelected(subj)}
                  style={{
                    padding: '12px 8px',
                    borderRight: isLastYear ? 'none' : '1px solid #333',
                    borderBottom: '1px solid #333',
                    background: bgColor,
                    minHeight: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: subj ? 'pointer' : 'default',
                    color: subj?.textColor || '#000000',
                    overflow: 'hidden',
                    transition: 'transform 0.2s, box-shadow 0.2s'
                  }}
                  onMouseEnter={(e) => subj && (e.currentTarget.style.transform = 'scale(1.02)', e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)')}
                  onMouseLeave={(e) => subj && (e.currentTarget.style.transform = 'scale(1)', e.currentTarget.style.boxShadow = 'none')}
                >
                  {subj && <div>{subj.courseId}</div>}
                </div>
              );
            })
          )).flat()
        ))}
      </div>

      {/* Modal */}
      {selected && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 }} onClick={() => setSelected(null)}>
          <div style={{ width: 520, position: 'relative' }} onClick={(e) => e.stopPropagation()}>
            <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', top: -10, width: 0, height: 0, borderLeft: '12px solid transparent', borderRight: '12px solid transparent', borderBottom: '12px solid #155c2b' }} />
            <div style={{ background: '#155c2b', color: '#fff', padding: '12px 16px', fontWeight: 800, borderRadius: 6 }}>{selected.courseId}</div>
            <div style={{ background: '#fff', padding: 18, border: '1px solid rgba(0,0,0,0.08)', borderTop: 'none', borderRadius: '0 0 8px 8px' }}>
              <h4 style={{ marginTop: 0 }}>{selected.courseName}</h4>
              <div style={{ color: '#666', marginBottom: 8 }}>Prerequisite: <strong style={{ color: '#333' }}>{selected.prerequisite || 'None'}</strong></div>
              <div style={{ color: '#666', marginBottom: 8 }}>Units: <strong style={{ color: '#333' }}>{selected.units || 'N/A'}</strong></div>
              <div style={{ color: '#666', marginBottom: 8 }}>Year Level: <strong style={{ color: '#333' }}>{selected.yearLevel || 'N/A'}</strong></div>
              <div style={{ color: '#666' }}>Semester: <strong style={{ color: '#333' }}>{selected.semester || 'N/A'}</strong></div>
              <div style={{ marginTop: 18, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                <button onClick={() => setSelected(null)} style={{ padding: '8px 12px', background: '#eee', border: 'none', borderRadius: 6, cursor: 'pointer' }}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
